<template>
  <v-app-bar dark app :color="$root.themeColor">
    <v-app-bar-title>
      <v-app-bar-nav-icon @click="toggleNavigationBar" v-if="visibleItem"
        ><v-icon>fas fa-bars</v-icon></v-app-bar-nav-icon
      >
    </v-app-bar-title>
    <v-spacer></v-spacer>

    <v-menu
      class="toolbar-menu-item"
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
      v-if="visibleItem"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          large
          text
          v-on="on"
          ref="personToolbar"
          @click="configRole()"
          :ripple="false"
        >
          <v-icon size="42">person</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="item.click"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <modal-personal-data
      v-if="this.isModalPDVisible"
      :active="this.isModalPDVisible"
      @closePD="actionsModalPersonalData"
      :key="this.PDKey"
    ></modal-personal-data>
    <modal-change-pass
      v-if="this.isModalChangePassVisible"
      :active="this.isModalChangePassVisible"
      @closeCP="actionsModalChangePass"
      :key="this.PassKey"
    >
    </modal-change-pass>
    <modal-users
      v-if="this.isModalUsersVisible"
      :active="this.isModalUsersVisible"
      @closeUS="actionsModalUsers"
      :key="this.GestUserKey"
    ></modal-users>
    <v-snackbar
      rounded
      :color="error"
      class="black--text"
      v-model="showResult"
      :timeout="2000"
      top
    >
      {{ result }}
    </v-snackbar>
  </v-app-bar>
</template>
<script>
import UserService from "../../services/UserService";
export default {
  data() {
    return {
      isModalPDVisible: false,
      selectedFile: null,
      json: null,
      visibleItem: true,
      PDKey: 0,
      isModalChangePassVisible: false,
      PassKey: 0,
      isModalUsersVisible: false,
      GestUserKey: 0,
      dialogSettings: false,
      error: "",
      showResult: false,
      result: "",
      items: [
        {
          icon: "mdi-account-edit",
          title: "Datos Personales",
          click: () => {
            this.isModalPDVisible = true;
          }
        },

        {
          icon: "mdi-account-lock",
          title: "Cambiar contraseña",
          click: () => {
            this.isModalChangePassVisible = true;
          }
        },
        {
          icon: "mdi-account-search",
          title: "Gestionar Usuarios",
          click: () => {
            this.isModalUsersVisible = true;
          }
        },
        {
          icon: "exit_to_app",
          title: "Cerrar sesión",
          click: () => {
            const vm = this;
            vm.$store.dispatch("auth/logout");
            vm.$router.push("/login");
          }
        }
      ]
    };
  },
  methods: {
    configRole() {
      var vm = this;
      console.log(vm.$store.state.auth.user.roles[0])
      if (vm.$store.state.auth.user.roles[0] != "ROLE_ADMIN") {
        this.items = vm.items.filter(
          item => item.title != "Gestionar Usuarios"
        );
      }
    },
    actionsModalPersonalData: async function(action, obj) {
      if (action == "confirmar") {
        try {
          await UserService.editUser(obj.id, obj);
          this.error = "success";
          this.result = "Datos actualizados";
          this.showResult = true;
          this.isModalPDVisible = false;
          this.PDKey += 1;
          this.$store.state.auth.user = obj;
        } catch (e) {
          this.error = "error";
          this.result = "Fallo al actualizar";
          this.showResult = true;
          this.isModalPDVisible = true;
        }
      } else if (action == "cerrar") {
        this.isModalPDVisible = false;
      } else if (action != "") {
        this.error = "error";
        this.result = action;
        this.showResult = true;
      }
    },
    actionsModalUsers: async function(action) {
      this.isModalUsersVisible = false;
      this.GestUserKey += 1;
    },
    actionsModalChangePass: async function(action, obj) {
      if (action == "confirmar") {
        try {
          await UserService.changePass(obj.id, obj);
          this.error = "success";
          this.result = "Contraseña actualizada";
          this.showResult = true;
          this.isModalChangePassVisible = false;
          this.PassKey += 1;
        } catch (e) {
          this.error = "error";
          this.result =
            "Fallo al actualizar la contraseña. Revise la contraseña antigua";
          this.showResult = true;
          this.isModalChangePassVisible = true;
        }
      } else if (action == "cerrar") {
        this.isModalChangePassVisible = false;
      } else if (action != "") {
        this.error = "error";
        this.result = action;
        this.showResult = true;
      }
    },
    toggleNavigationBar() {
      const vm = this;

      vm.$emit("toggleNavigationBar");
    }
  }
};
</script>
<style>
.toolbar-menu-item {
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/Toolbar.vue